module.exports = __webpack_public_path__ + "static/media/equatorial-guinea.78c876ee.png";